import { ApiError } from '../../shared/api/client';
import { ErrorState } from '../../shared/ui/page';

/**
 * A refused request, with every reason the API gave. A posting refusal names the line, the account
 * and the rule for each failure (FRD-FIN-036), so all of them are listed, not only the summary.
 */
export function RefusalState({ error }: { error: Error }) {
  const reasons = error instanceof ApiError ? (error.problem?.errors ?? []) : [];
  const describe = (field: string) => {
    const line = /^lines\[(\d+)\]$/.exec(field);
    return line?.[1] === undefined ? 'Document' : `Line ${String(parseInt(line[1], 10) + 1)}`;
  };
  return (
    <ErrorState
      message={
        reasons.length === 0
          ? error.message
          : `${error.message} — ${reasons
              .map((r) => `${describe(r.field)}: ${r.message} (${r.rule})`)
              .join('; ')}`
      }
    />
  );
}
